export default {
  common: {
    error: "Noe gikk galt",
    reload: "Last inn på nytt",
    errorNotification: "Vi har blitt varslet og vil fikse det så snart som mulig. Hvis problemet vedvarer, vennligst",
    contactUs: "Kontakt oss.",
    language: "Språk",
    loading: "Laster...",
    loadingText: "Laster",
    save: "Lagre",
    savedSuccessfully: "Lagret Vellykket",
    saving: "Lagrer...",
    cancel: "Avbryt",
    edit: "Rediger",
    delete: "Slett",
    add: "Legg til",
    search: "Søk",
    filter: "Filter",
    clear: "Tøm",
    preview: "Forhåndsvisning",
    default: "Standard: {{value}}",
    optional: "Valgfritt",
    required: "Påkrevd",
    noData: "Ingen data",
  },
  // Places navigation
  places: {
    navigation: {
      locations: "Lokasjoner",
      cities: "Byer", 
      regions: "Regioner",
      countries: "Länder",
      showOnMap: "Vis på kart",
      addLocation: "Legg til lokasjon"
    },
    welcome: {
      title: "Velkommen til Locations So Super.",
      subtitle: "Velg en seksjon fra navigasjonen for å komme i gang."
    }
  },

  // Cities section
  cities: {
    title: "Byer",
    resourceSingular: "by",
    resourcePlural: "byer",
    headings: {
      name: "Navn",
      status: "Status",
      locations: "Lokasjoner", 
      region: "Region",
      country: "Land"
    },
    breadcrumbs: {
      cities: "Byer"
    }
  },

  // Countries section  
  countries: {
    title: "Länder",
    resourceSingular: "land", 
    resourcePlural: "länder",
    headings: {
      name: "Navn",
      status: "Status",
      locations: "Lokasjoner",
      cities: "Byer",
      regions: "Regioner"
    },
    breadcrumbs: {
      countries: "Länder"
    }
  },

  // Regions section
  regions: {
    title: "Regioner",
    resourceSingular: "region",
    resourcePlural: "regioner", 
    headings: {
      name: "Navn",
      status: "Status",
      locations: "Lokasjoner",
      cities: "Byer",
      country: "Land"
    },
    breadcrumbs: {
      regions: "Regioner"
    }
  },

  // Map section
  map: {
    title: "Kart",
    breadcrumbs: {
      locations: "Lokasjoner"
    }
  },

  // Import section
  import: {
    title: "CSV Import",
    breadcrumbs: {
      locations: "Lokasjoner"
    },
    new: {
      title: "Importer lokasjoner med CSV",
      description: "Last ned en eksempel CSV-mal for å se et eksempel på det nødvendige formatet",
      sampleTemplate: "eksempel CSV-mal",
      uploadAndContinue: "Last opp og fortsett",
      abortOnError: "Avbryt ved feil",
      abortOnErrorHelp: "Hvis det er en feil, vil importen avbryte, vise feilen og ingen lokasjoner vil bli importert.",
      needHelp: "Trenger hjelp med å importere lokasjoner?"
    },
    show: {
      title: "CSV import",
      youCanLeavePage: "Du kan forlate denne siden",
      backgroundMessage: "Importen din vil fortsatt kjøre i bakgrunnen",
      importProgress: "Import fremdrift",
      imported: "Importert",
      suffix: "lokasjoner",
      importLog: "Import logg",
      cancelImport: "Avbryt import",
      cancelConfirmation: {
        title: "Avbryt import",
        message: "Er du sikker på at du vil avbryte denne importjobben? Denne handlingen kan ikke angres.",
        note: "Merk: For pågående jobber må jobben fullføres og den vil bli slettet rett etter.",
        yesCancel: "Ja, avbryt import",
        noContinue: "Nei, fortsett import"
      },
      report: "Rapport",
      failedLocations: "Feilede lokasjoner",
      uploadAnother: "Last opp en annen CSV",
      backToLocations: "Tilbake til lokasjoner",
      importSucceeded: "Import lyktes",
      importFailed: "Import feilet"
    },
    messages: {
      uploadSuccess: "CSV lastet opp vellykket",
      uploadError: "Kunne ikke laste opp CSV",
      pending: "Import har ikke startet ennå",
      inProgress: "Import pågår",
      completed: "Import fullført",
      invalidHeader: "Følgende kolonner kreves",
      invalidCsvFile: "Ugyldig CSV-fil",
      aborted: "Import avbrutt",
      failed: "Import feilet",
      cancelled: "Import kansellert"
    },
    errors: {
      csvTooLarge: "CSV er for stor",
      languageNotEnabled: "Språket '{{language}}' er ikke aktivert for denne butikken. Vennligst aktiver det i Innstillinger > Språk først.",
      fieldNotTranslatable: "Feltet '{{field}}' er ikke oversettbart. Oversettbare felt er: {{fields}}",
      locationError: "Lokasjon med slug: {{slug}} - {{error}}",
      planLimit: "Du er på din planbegrensning for lokasjoner"
    }
  },

  // Location form
  location: {
    index: {
      title: "Lokasjoner",
      addLocation: "Legg til lokasjon",
      import: "Import",
      noPrioritySet: "Ingen prioritet satt",
      published: "Publisert",
      draft: "Kladd",
      resourceSingular: "lokasjon",
      resourcePlural: "lokasjoner",
      headings: {
        name: "Navn",
        status: "Status", 
        city: "By",
        region: "Region",
        country: "Land",
        priority: "Prioritet"
      }
    },
    form: {
      title: "Legg til lokasjon",
      editTitle: "Rediger lokasjon",
      basicInformation: "Grunnleggende informasjon",
      name: "Navn",
      namePlaceholder: "f.eks. Brians Murstein",
      nameHelpDefault: "Standard: {{defaultName}}",
      details: "Detaljer",
      description: "Beskrivelse",
      descriptionPlaceholder: "Fortell kundene hva som gjør denne lokasjonen spesiell",
      address: "Adresse",
      addressPlaceholder: "123 Hovedgate, By, Land",
      addressLine1: "Adresselinje 1",
      addressLine2: "Adresselinje 2",
      postalZipCode: "Postnummer",
      city: "By",
      stateProvinceRegion: "Fylke / Provins / Region",
      country: "Land",
      phone: "Telefon",
      phonePlaceholder: "+47 123 45 678",
      email: "E-post", 
      emailPlaceholder: "butikk@eksempel.com",
      website: "Nettside",
      websitePlaceholder: "https://www.example.com",
      image: "Bilde",
      imagePlaceholder: "Skriv inn bilde-URL",
      status: "Status",
      statusActive: "Aktiv",
      statusInactive: "Inaktiv",
      statusDraft: "Kladd",
      priority: "Prioritet",
      priorityHelpText: "Høyere prioritetslokasjoner vises først i søkeresultater",
      findOnMapButton: "Finn på kart"
    },
    validation: {
      addressNotFound: "Kunne ikke finne adresse",
      createSuccess: "Lokasjon opprettet vellykket", 
      updateSuccess: "Lokasjon oppdatert vellykket",
      checkFields: "Vennligst sjekk feltene dine",
      findOnMap: "Vennligst finn lokasjonen din på kartet før du lagrer"
    },
    errors: {
      loading: "Feil ved lasting av lokasjon"
    },
    actions: {
      save: "Lagre lokasjon",
      delete: "Slett lokasjon",
      preview: "Forhåndsvisning"
    },
    customFields: {
      title: "Egendefinerte felt",
      noCustomFields: "Ingen egendefinerte felt konfigurert",
      configureFields: "Konfigurer felt",
      emptyState: "Du har ikke konfigurert noen egendefinerte felt ennå. Egendefinerte felt lar deg legge til tilleggsinformasjon spesifikt for dine forretningsbehov."
    },
    openingHours: {
      title: "Åpningstider",
      checkboxLabel: "Denne lokasjonen har åpning- og lukketider",
      statusOpen: "Åpen",
      statusOpen24h: "Åpen 24T",
      statusClosed: "Stengt",
      openingTimeLabel: "Åpningstid",
      closingTimeLabel: "Lukketid",
      days: {
        monday: "Mandag",
        tuesday: "Tirsdag", 
        wednesday: "Onsdag",
        thursday: "Torsdag",
        friday: "Fredag",
        saturday: "Lørdag",
        sunday: "Søndag"
      }
    },
    table: {
      sortOptions: {
        recentlyAdded: "Nylig lagt til",
        recentlyModified: "Nylig endret"
      },
      filters: {
        status: "Status",
        taggedWith: "Taggert med",
        locationStatus: "Lokasjonsstatus",
        noTagsToShow: "Ingen tagger å vise",
        searchPlaceholder: "Søk"
      },
      bulkActions: {
        setPublished: "Sett som publisert",
        setUnpublished: "Sett som upublisert", 
        setPriority: "Sett prioritet",
        deleteLocations: "Slett lokasjoner",
        exportCSV: "Eksporter som CSV"
      },
      appliedFilters: {
        statusIs: "Status er {{status}}",
        taggedWith: "Taggert med {{tag}}",
        nameIncludes: "Navn inkluderer {{search}}"
      },
      modals: {
        deleteTitle: "Slett lokasjoner",
        deleteMessage: "Er du sikker på at du vil slette {{count}}?",
        deleteMessageAll: "Er du sikker på at du vil slette alle lokasjoner?",
        prioritiseTitle: "Prioriter {{count}} lokasjoner",
        prioritiseTitleAll: "Prioriter alle lokasjoner",
        delete: "Slett",
        cancel: "Avbryt"
      },
      emptyState: {
        noResultsHeading: "Kunne ikke finne noen {{resourcePlural}}",
        noResultsText: "Prøv å endre filtrene eller søkeordet",
        noDataHeading: "Legg til en lokasjon for å fylle {{resourcePlural}}",
        addLocation: "Legg til lokasjon",
        importFromCSV: "Importer fra CSV"
      },
      pagination: {
        label: "Side {{page}} av {{pages}}"
      },
      messages: {
        updatedSuccessfully: "Oppdatert vellykket",
        deletedSuccessfully: "Slettet vellykket", 
        exportedSuccessfully: "Eksportert vellykket",
        error: "Noe gikk galt"
      }
    }
  },

  // SEO Editor
  seo: {
    title: "Sideinnhold",
    editTemplate: "Rediger SEO-mal", 
    pageTitle: "Tittel",
    pageDescription: "Beskrivelse",
    metaTitle: "Tittel",
    metaDescription: "Beskrivelse",
    urlHandle: "URL-håndter",
    searchEnginePreview: "Søkemotorlistingsforhåndsvisning",
    editMeta: "Rediger Meta",
    previewMeta: "Forhåndsvis Meta",
    loading: "Laster...",
    editingLocaleHelp: "Redigerer {{locale}}-innhold."
  },

  // SEO Templates section
  seoTemplates: {
    title: "SEO-maler",
    breadcrumbs: {
      seoTemplates: "SEO-maler"
    },
    template: {
      title: "{{templateName}}-mal - {{locale}}",
      discardChanges: "Forkast endringer"
    },
    form: {
      pageContent: "Sideinnhold",
      searchEnginePreview: "Søkemotorlistingsforhåndsvisning",
      title: "Tittel",
      description: "Beskrivelse",
      pageTitle: "Sidetittel",
      metaDescription: "Meta-beskrivelse",
      editingLocaleHelp: "Redigerer {{locale}}-oversettelser. Tomme felt vil vise innhold fra {{defaultLocale}}.",
      defaultValue: "Standard: {{value}}"
    },
    language: {
      label: "Språk",
      defaultHelp: "Dette er ditt standardspråk",
      editingHelp: "Redigerer {{locale}}-oversettelser. Tomme felt vil vise {{defaultLocale}}-innhold."
    },
    banner: {
      multipleLanguagesDisabled: "Flere språk ikke aktivert",
      enableInSettings: "Aktiver i Innstillinger",
      multipleLanguagesInfo: "For å administrere SEO-maler for flere språk, aktiver internasjonalisering i språkinnstillingene dine. Viser for øyeblikket kun {{locale}}-maler."
    },
    badges: {
      errors: "Feil!",
      unsaved: "Ulagret"
    },
    messages: {
      saveSuccess: "SEO-maler lagret vellykket",
      saveError: "Kunne ikke lagre maler",
      error: "Feil..."
    }
  },

  // Area form
  area: {
    form: {
      basicInformation: "Grunnleggende informasjon",
      name: "Navn",
      save: "Lagre",
      saving: "Lagrer...",
      cancel: "Avbryt",
      yourLocationsIn: "Dine lokasjoner i {{name}}",
      tableHeadings: {
        name: "Navn",
        status: "Status",
        city: "By",
        region: "Region",
        country: "Land"
      },
      resourceName: {
        singular: "{{name}}-lokasjon",
        plural: "lokasjoner i {{name}}"
      }
    }
  },

  // Settings section
  settings: {
    navigation: {
      map: "Kart",
      tags: "Tagger",
      customFields: "Egendefinerte felt",
      languages: "Språk",
      plan: "Plan",
      addTag: "Legg til tagg",
      addField: "Legg til felt"
    },
    planBadges: {
      trial: "!",
      endsSoon: "Slutter snart"
    },
    common: {
      loading: "Laster...",
      error: "Feil...",
      breadcrumbs: {
        settings: "Innstillinger"
      },
      skeleton: {
        customFields: "Egendefinerte felt",
        addField: "Legg til felt",
        name: "Navn",
        contentType: "Innholdstype",
        usedIn: "Brukt i",
        field: "Felt",
        fields: "Felt"
      },
      messages: {
        savedSuccessfully: "{{setting}}-innstillinger lagret vellykket",
        couldntSave: "Kunne ikke lagre {{setting}}-innstillinger"
      }
    },
    map: {
      title: "Kart",
      messages: {
        savedSuccessfully: "Kartinnstillinger lagret vellykket",
        couldntSave: "Kunne ikke lagre innstillinger"
      },
      mapboxToken: {
        title: "Mapbox-token",
        description: "Skriv inn din Mapbox-token for å drive din butikksøker",
        label: "Mapbox-token",
        placeholder: "Skriv inn token her for å fortsette å bruke kartet ditt.",
        placeholderManaged: "Skriv inn token her for å fortsette å bruke kartet ditt når du går tom for gratis kartlastinger.",
        helpText: "Følg våre instruksjoner for å opprette en Mapbox-nøkkel, lim deretter inn nøkkelen din ovenfor. Hvis du støter på problemer, vennligst ta kontakt for hjelp.",
        linkInstructions: "instruksjoner for å opprette en Mapbox-nøkkel",
        linkSupport: "ta kontakt for hjelp"
      },
      managedToken: {
        title: "Kartlastinger",
        description: "Du har opptil {{max}} gratis kartlastinger med en administrert token, etter det må du opprette din egen token."
      },
      appearance: {
        title: "Utseende",
        description: "Endre utseendet på kartet ditt"
      },
      mapStyle: {
        title: "Kartstil",
        options: {
          streets: "Gater",
          outdoors: "Utendørs", 
          light: "Lys",
          dark: "Mørk",
          satellite: "Satellitt",
          satelliteStreets: "Satellittgater",
          navigationDay: "Navigasjon dag",
          navigationNight: "Navigasjon natt"
        }
      },
      searchBehaviour: {
        title: "Søkeatferd",
        description: "Kontrollerer hvordan besøkende finner lokasjoner på kartet ditt.",
        geolocateLabel: "Automatisk estimer besøkendes plassering og vis nærliggende butikker",
        geolocateHelp: "Hvis geolokalisering lykkes, vil kartet flytte seg for å fokusere nær besøkenden. Hvis en estimert plassering ikke kan finnes, vil kartet forbli på startposisjonen.",
        filterBehaviour: {
          title: "Filteratferd",
          all: {
            label: "Alle tagger",
            help: "For at en lokasjon skal vises i filtre, må den ha alle de valgte taggene"
          },
          any: {
            label: "Alle tagger", 
            help: "For at en lokasjon skal vises i filtre, kan den ha noen av de valgte taggene"
          }
        },
        keepSearchInView: {
          label: "Hold søkemarkør i syn",
          help: "Når søkeresultater vises, vil kartet zoome ut for å vise alle matchende lokasjoner"
        },
        distanceUnits: {
          title: "Avstandsenheter",
          km: "Kilometer",
          miles: "Miles"
        },
        maxResults: {
          label: "Maks resultater",
          help: "Begrens antall lokasjoner vist i søkeresultater",
          options: {
            results30: "30 resultater"
          }
        },
        maxDistance: {
          label: "Maks avstand", 
          help: "Vis kun lokasjoner innenfor denne avstanden fra søkepunktet",
          options: {
            unlimited: "Ubegrenset"
          }
        },
        showLocationNames: {
          label: "Vis lokasjonsnavn i forslag",
          help: "Vis lokasjonsnavn i søkeforslag"
        },
        sortByPriority: {
          label: "Sorter etter prioritet i stedet for avstand",
          help: "Det er sterkt anbefalt å sette en maksimal avstand (som ikke er Ubegrenset) hvis denne boksen er merket. Ellers vil kundene dine se fjerne lokasjoner som har høy prioritet listet over de som er innenfor en rimelig avstand fra dem (eller deres søkeforespørsel, mer spesifikt)."
        }
      },
      searchResults: {
        title: "Søkeresultater",
        description: "Kontrollerer hvordan lokasjoner returneres på kartet ditt.",
        locationsLabel: "Søkeresultattekst",
        locationsHelp: "Tekst vist over søkeresultater (f.eks. 'Viser 5 lokasjoner')",
        prefixLabel: "Søkeresultatprefiks", 
        prefixHelp: "Tekst vist før antall resultater"
      },
      popups: {
        title: "Popups",
        showPopups: {
          label: "Vis popups",
          help: "Vis lokasjonsdetaljer når besøkende klikker på kartmarkører"
        }
             },
       whitelabel: {
         title: "Whitelabel",
         hideLabel: "Skjul powered by-tekst",
         hideHelp: "Fjern vårt merkevare fra din butikksøker"
       }
    },
    languages: {
      title: "Språk",
      error: "Feil...",
      messages: {
        savedSuccessfully: "Språkinnstillinger lagret vellykket",
        couldntSave: "Kunne ikke lagre språkinnstillinger"
      },
      banner: {
        upgradeTitle: "Flerspråklig støtte krever planoppgradering",
        upgradeAction: "Oppgrader til Superest",
        upgradeMessage: "Du kan fortsatt endre standardspråket ditt, men å aktivere flere språk krever en oppgradering.",
        disabledMessage: "Flerspråklige innstillinger er deaktivert på din nåværende plan"
      },
      defaultLanguage: {
        title: "Standardspråk", 
        description: "Velg ditt primære språk som innholdet ditt vil bli vist på.",
        label: "Standardspråk",
        help: "Dette språket vil bli brukt når ingen spesifikk språk er forespurt"
      },
      internationalization: {
        title: "Internasjonalisering",
        description: "Aktiver flere språk. Nå flere kunder og øk SEO-en din.",
        enableLabel: "Aktiver flere språk",
        enableHelp: "La kunder se din butikksøker på forskjellige språk"
      },
      supportedLanguages: {
        title: "Ytterligere støttede språk",
        description: "Velg ytterligere språk du vil støtte. Når du har aktivert et språk, vil du se muligheten til å gi oversettelser gjennom hele appen. For støttede språk vil standard SEO-maler, samt vanlige variabeltemaer bli generert automatisk.",
        defaultLocaleNote: "Dette er ditt standardspråk og kan ikke deaktiveres",
        shopifyEnabled: {
          label: "Dette språket er aktivert i min Shopify-butikk",
          importantNote: "Viktig:",
          description: "Fjern avkrysningen i boksen ovenfor hvis dette språket ikke er aktivert og publisert for din Shopify-butikk. Det anbefales å aktivere språket for din Shopify-butikk først ved å gå til Innstillinger > Språk i din Shopify-admin hvis du ikke allerede har gjort det for en smidigere kundeopplevelse."
        },
        urlFormats: {
          cleanUrls: "Rene URLer:",
          betterSeo: "Bedre SEO og brukeropplevelse",
          queryUrls: "Spørreparameter-URLer:",
          considerEnabling: "Vurder å aktivere i Shopify for bedre URLer"
        },
        preview: {
          button: "Forhåndsvisning",
          tooltip: "Forhåndsvis {{language}} butikksøker"
        },
        tooltips: {
          noTemplates: "Ingen standard SEO-maler tilgjengelig for dette språket. Du kan enkelt opprette egendefinerte oversettelser."
        }
      }
    },
    tags: {
      title: "Tagger",
      addTag: "Legg til tagg",
      error: "Feil",
      messages: {
        deletedSuccessfully: "Tagger slettet vellykket",
        couldntDelete: "Tagger kunne ikke slettes",
        savedSuccessfully: "Tagg lagret vellykket",
        couldntSave: "Vennligst sjekk feltene dine",
        tagDeleted: "Tagg slettet vellykket"
      },
      resourceName: {
        singular: "tagg",
        plural: "tagger"
      },
      filters: {
        anyGroup: "Alle grupper",
        inGroup: "I gruppe",
        tagGroup: "Taggruppe"
      },
      appliedFilters: {
        inGroup: "I {{group}}-gruppe",
        nameContains: "Tagnavn inneholder {{query}}"
      },
      bulkActions: {
        deleteTag: "Delete tag",
        deleteTags: "Delete tags"
      },
      form: {
        language: "Språk",
        title: "Tittel",
        description: "Beskrivelse",
        group: "Gruppe",
        groupPlaceholder: "Velg gruppe",
        addGroup: "Legg til",
        editingTranslations: "Redigerer {{language}}-oversettelser. Tomme felt vil vise innhold fra {{defaultLanguage}}.",
        defaultValue: "Standard: {{value}}",
        image: "Bilde",
        imageUrl: "Bilde-URL"
      },
      actions: {
        save: "Lagre",
        deleteTag: "Slett tagg"
      },
      new: {
        title: "Legg til tagg",
        messages: {
          createSuccess: "Tagg opprettet vellykket",
          checkFields: "Vennligst sjekk feltene dine"
        },
        actions: {
          createTag: "Opprett tagg"
        }
      }
    },
    customFields: {
      title: "Egendefinerte felt",
      addField: "Legg til felt",
      error: "Feil",
      resourceName: {
        singular: "Felt",
        plural: "Felt"
      },
      headings: {
        name: "Navn",
        contentType: "Innholdstype",
        usedIn: "Brukt i"
      },
      emptyState: {
        heading: "Opprett og administrer dine egendefinerte felt",
        createAction: "Opprett felt",
        description: "Bruk egendefinerte felt for unike attributter om lokasjonene dine. Disse feltene kan være alt fra sosiale profiler til butikksjefens navn og e-post"
      },
      pluralization: {
        location: "lokasjon",
        locations: "lokasjoner"
      },
      form: {
        name: "Navn",
        contentType: "Innholdstype",
        key: "Nøkkel",
        keyPrefix: "location.fields.",
        keyHelp: "Bruk denne nøkkelen for å få tilgang til en lokasjons {{name}}-innhold i dine liquid-maler.",
        translations: {
          title: "Oversettelser",
          showTranslations: "Vis oversettelser",
          hideTranslations: "Skjul oversettelser",
          description: "Oversettelser er valgfrie. Tomme felt vil vise {{language}}-feltnavnet.",
          nameTranslation: "Navn ({{language}})",
          defaultValue: "Standard: {{value}}"
        }
      },
      messages: {
        savedSuccessfully: "Felt lagret vellykket",
        couldntSave: "Felt kunne ikke lagres",
        deletedSuccessfully: "Felt slettet vellykket",
        couldntDelete: "Felt kunne ikke slettes"
      },
      actions: {
        delete: "Slett"
      },
      new: {
        title: "Legg til felt",
        messages: {
          savedSuccessfully: "Felt lagret vellykket",
          couldntSave: "Felt kunne ikke lagres"
        }
      },
      contentTypes: {
        text: "Tekst",
        textArea: "Tekstområde", 
        email: "E-post",
        number: "Nummer",
        phoneNumber: "Telefonnummer",
        time: "Tid",
        url: "URL"
      }
    },
    plan: {
      title: "Plan",
      error: "Feil",
      changePlan: "Endre plan",
      usdPerMonth: "USD / måned",
      sections: {
        yourPlanIncludes: "Din plan inkluderer",
        nextBillingDate: "Neste faktureringsdato",
        trial: "Prøveperiode"
      },
      banners: {
        planUpdated: "Din plan har blitt oppdatert",
        thankYouUpgrading: "Takk for oppgraderingen!",
        letUsKnow: "La oss vite",
        improvementText: "hvis det er noe vi kan gjøre bedre."
      },
      locations: {
        upTo: "Opptil",
        locations: "lokasjoner",
        unlimited: "Ubegrensede lokasjoner",
        used: "brukt",
        ofUsed: "{{used}} av {{max}} brukt"
      },
      trial: {
        daysLeft: "{{days}} dager igjen",
        daysUsed: "{{used}} av {{total}} dager brukt",
        selectPlan: "Velg en plan",
        currentPlan: "Nåværende plan",
        trialBadge: "Prøveperiode",
        currentBadge: "Nåværende",
        yourTrialJustStarted: "Din prøveperiode startet nettopp",
        trialEndsAfterToday: "Din prøveperiode slutter etter i dag",
        trialEndsTomorrow: "Din prøveperiode slutter i morgen",
        daysLeftInTrial: "{{days}} dager igjen i din prøveperiode",
        continueAddingLocations: "Fortsett å legge til lokasjoner etter {{date}} ved å velge en plan",
        selectPlanToday: "Vennligst velg en plan i dag for å fortsette å legge til lokasjoner"
      },
      footer: {
        description: "Administrer eller endre din Locations So Super-plan. Se våre",
        termsOfService: "brukervilkår",
        and: "og",
        privacyPolicy: "personvernregler"
      },
      features: {
        analytics: {
          title: "Analyser",
          description: "Finn ut hvordan folk bruker lokasjonene dine og hvor de søker etter"
        },
        internationalization: {
          title: "Flerspråklig støtte",
          description: "Øk SEO og nå flere kunder i målmarkeder ved å aktivere flere språk"
        },
        customThemes: {
          editLiquid: {
            title: "Rediger tema liquid-maler",
            description: "Vis lokasjonsdata på den måten du liker med tilgang til tema liquid"
          },
          editStructuredData: {
            title: "Rediger forretningsstrukturerte data",
            description: "Rediger hvordan Google forstår sider ved å redigere dine strukturerte data"
          }
        }
      },
      edit: {
        title: "Endre plan",
        allPlansInclude: "Alle planer ovenfor inkluderer",
        needingMoreLocations: "Trenger flere lokasjoner?",
        footerQuestion: "Har du spørsmål før du starter?",
        sendMessage: "send oss en melding",
        allFeatures: {
          seoDirectory: {
            title: "SEO-katalog og landingssider",
            description: "Automatisk opprett en SEO-katalog av alle dine lokasjoner, byer og regioner"
          },
          mapPage: {
            title: "Kartside med søk og filter",
            description: "Søk og filtrer alle dine lokasjoner med et kart drevet av Mapbox"
          },
          tags: {
            title: "Tagger",
            description: "Opprett tagger med bilder og beskrivelser og grupper dem"
          },
          openingHours: {
            title: "Åpningstider",
            description: "Sett og vis åpningstidene for dine lokasjoner"
          },
          mapStyles: {
            title: "Kartstiler",
            description: "Endre utseendet på kartene med en rekke forhåndsdefinerte stiler"
          },
          customFields: {
            title: "Egendefinerte felt",
            description: "Legg til alle nye felt du vil, fra sosiale lenker til butikksjef"
          },
          csvUpload: {
            title: "Last opp og eksporter med CSV",
            description: "Last opp og rediger lokasjonene dine i bulk."
          },
          richSnippets: {
            title: "Rike utdrag",
            description: "Hjelp Google å forstå sider bedre med lokale forretningsstrukturerte data"
          },
          directionsAndCalls: {
            title: "Rutebeskrivelser og anrop",
            description: "Besøkende kan enkelt få rutebeskrivelser og ringe til lokasjonene"
          },
          languageSupport: {
            title: "Språkstøtte",
            description: "Endre standardspråk til noe annet enn engelsk. Oversettelsesmaler tilgjengelig for 32 hovedspråk for enkel oppsett."
          }
        }
      },
      planCard: {
        bestToCustomize: "Best to customize",
        currentPlan: "Current plan",
        chooseThisPlan: "Choose this plan",
        locationsSection: "Locations",
        featuresSection: "Features",
        upTo: "Up to",
        locations: "locations",
        tooltipTooManyLocations: "You have too many locations and/or enabled languages for this plan."
      },
      confirmation: {
        error: "Feil ved bekreftelse av plan"
      }
    }
  },

  // Themes section
  themes: {
    title: "Temaer",
    currentTheme: {
      title: "Nåværende tema",
      description: "Dette er temaet kundene ser når de besøker din lokasjonsapp."
    },
    themeLibrary: {
      title: "Temabibliotek", 
      description: "Administrer dine lokasjonslokasjonstemaer. Legg til og publiser temaer for å endre utseendet på din online lokasjon."
    },
    skeleton: {
      currentThemeDescription: "Dette er temaet kundene dine ser når de bruker din lokasjonsapp."
    },
    modal: {
      overrideTitle: "Overstyr nåværende tema?",
      override: "Overstyr",
      cancel: "Avbryt",
      undoWarning: "Denne handlingen kan ikke angres."
    },
    messages: {
      publishSuccess: "Tema publisert vellykket",
      publishError: "Kunne ikke publisere tema",
      error: "Noe gikk galt"
    },
    emptyStates: {
      settings: {
        heading: "Dette temaet har ingen innstillinger",
        description: "Opprett innstillinger i malredigereren.",
        createSettings: "Opprett innstillinger",
        upgradePlan: "Oppgrader plan",
        upgradeRequired: "Oppgrader plan for å opprette innstillinger"
      },
      language: {
        heading: "Dette temaet har ingen språktermer",
        description: "Opprett språktermer i malredigereren.",
        createLanguageTerms: "Opprett språktermer",
        upgradePlan: "Oppgrader plan",
        upgradeRequired: "Oppgrader plan for å opprette språktermer"
      }
    },
    templates: {
      categories: {
        templates: "Maler",
        schemas: "Skjemaer",
        styles: "Stiler",
        liquidReference: "Liquid-referanse"
      },
      items: {
        landing: "Landing",
        directory: "Katalog",
        country: "Land",
        region: "Region",
        city: "By",
        location: "Lokasjon",
        language: "Språk",
        settings: "Innstillinger",
        stylesheet: "Stilark"
      },
      errors: {
        errorsInTemplate: "Feil i mal",
        error: "Feil"
      },
      badges: {
        errors: "Feil!",
        unsaved: "Ulagret"
      },
      actions: {
        viewTheme: "Vis tema",
        discard: "Forkast",
        save: "Lagre"
      }
    },
    language: {
      messages: {
        saveSuccess: "Temaspråkoversettelser lagret vellykket",
        saveError: "Tema kunne ikke lagres"
      },
      form: {
        language: "Språk",
        defaultLanguageHelp: "Dette er ditt standardspråk",
        translationHelp: "Redigerer oversettelser for {{selectedLocale}}. Tomme felt vil vise innhold fra {{defaultLocale}} (ditt standardspråk)."
      },
      banner: {
        multipleLanguagesNotEnabled: {
          title: "Flere språk ikke aktivert",
          action: "Aktiver i Innstillinger",
          description: "For å administrere oversettelser for flere språk, aktiver internasjonalisering i språkinnstillingene dine. Viser for øyeblikket kun {{locale}}-oversettelser."
        },
        translating: {
          title: "Oversetter fra {{from}} til {{to}}",
          description: "Alle felt du lar stå tomme vil automatisk vise {{defaultLocale}}-innholdet til kundene dine. Oversett kun feltene hvor du vil ha annet innhold i {{selectedLocale}}."
        }
      },
      accessLanguageTerms: "Få tilgang til {{category}}-språktermer i liquid med {{code}}",
      fields: {
        // Common language fields - add specific ones as needed
        title: "Tittel",
        description: "Beskrivelse",
        heading: "Overskrift",
        subheading: "Underoverskrift",
        button_text: "Knappetekst",
        link_text: "Lenketekst",
        placeholder: "Plassholder",
        label: "Etikett",
        help_text: "Hjelpetekst",
        error_message: "Feilmelding",
        success_message: "Suksessmelding",
        
        // Opening hours
        Monday: "Mandag",
        Tuesday: "Tirsdag",
        Wednesday: "Onsdag",
        Thursday: "Torsdag",
        Friday: "Fredag",
        Saturday: "Lørdag",
        Sunday: "Søndag",
        opening_hours_format: "Åpningstider format",
        closes_at_format: "Stenger kl format",
        opens_at_format: "Åpner kl format",
        opens_on: "Åpner på",
        open_24h: "Åpen 24t",
        open: "Åpen",
        closed: "Stengt",
        closes_at: "Stenger kl",
        opens_at: "Åpner kl",
        
        // Map
        search_map: "Søk kart",
        search_area: "Søk dette området",
        view_map: "Kart",
        view_list: "Liste",
        open_filters: "Filtre",
        stores_near_you: "Butikker nær deg",
        header: "Finn en butikk!",
        search_placeholder: "Skriv et postnummer eller adresse...",
        no_listings: "Vi beklager, vi kan ikke finne noen lokasjoner for søket ditt. Prøv å endre filtrene eller søkestedet",
        
        // Directory
        view_directory: "Butikkskatalog",
        
        // Location
        get_directions: "Rutebeskrivelser",
        call: "Ring",
        view_website: "Nettside",
        email: "E-post",
        opening_hours_header: "Åpningstider",
        description_header: "Informasjon",
        phone_number_header: "Telefon",
        address_header: "Adresse",
        tag_groups_to_display: "Taggrupper å vise"
      },
      categories: {
        // Common language categories - add specific ones as needed
        general: "Generelt",
        navigation: "Navigasjon",
        forms: "Skjemaer",
        buttons: "Knapper",
        messages: "Meldinger",
        errors: "Feil",
        opening_hours: "Åpningstider",
        map: "Kart",
        directory: "Katalog",
        location: "Lokasjon"
      }
    },
    settings: {
      messages: {
        saveSuccess: "Tema lagret vellykket",
        saveError: "Tema kunne ikke lagres"
      },
      accessSettings: "Få tilgang til {{category}}-innstillinger i liquid med {{code}}",
      fields: {
        // Colors
        color_text: "Fargetekst",
        color_text_heading: "Fargetekst overskrift", 
        color_background: "Fargebakgrunn",
        color_accent: "Fargeakksent",
        color_text_positive: "Fargetekst positiv",
        color_text_negative: "Fargetekst negativ",
        dark_theme: "Mørkt tema",
        color_marker: "Fargemarkør",
        color_search_marker: "Fargesøkemarkør",
        
        // Typography
        base_font_size: "Grunnleggende skriftstørrelse",
        
        // Buttons
        border_radius: "Kantradius",
        
        // Images
        aspect_ratio: "Bildestørrelse",
        fit: "Tilpass",
        
        // Spacing
        page_width: "Sidebredde",
        page_width_small: "Sidebredde liten",
        gutter_desktop: "Gutter desktop",
        gutter_mobile: "Gutter mobil",
        desktop_vertical_spacing: "Desktop vertikal avstand",
        mobile_vertical_spacing: "Mobil vertikal avstand",
        
        // Breakpoints
        breakpoint_xs: "Brytepunkt XS",
        breakpoint_sm: "Brytepunkt SM",
        breakpoint_md: "Brytepunkt MD",
        
        // Map
        search_on_move: "Søk ved bevegelse",
        scroll_to_zoom: "Rull for å zoome",
        
        // Landing page
        sidebar_width: "Sidepanelbredde",
        sidebar_min_height: "Sidepanel min høyde",
        marker_image_src: "Markør bildekilde",
        show_filter_descriptions: "Vis filterbeskrivelser",
        
        // Location page
        tag_groups_to_display: "Taggrupper å vise",
        tag_groups_to_display_as_icons: "Taggrupper å vise som ikoner",
        show_related_locations: "Vis relaterte lokasjoner",
        
        // Locations
        hide_regions: "Skjul regioner"
      },
      categories: {
        colors: "Farger",
        typography: "Typografi",
        buttons: "Knapper",
        images: "Bilder",
        spacing: "Avstand",
        breakpoints: "Brytepunkter",
        map: "Kart",
        landing_page: "Landingsside",
        location_page: "Lokasjonsside",
        locations: "Lokasjoner"
      }
    },
    navigation: {
      sublimeTheme: "Sublime-tema",
      settings: "Innstillinger",
      language: "Språk",
      templates: "Maler",
      changeTheme: "Endre tema",
      viewDirectory: "Vis katalog",
      viewLandingPage: "Vis landingsside"
    },
    card: {
      lastUpdated: "Sist oppdatert",
      view: "Vis",
      customize: "Tilpass",
      publish: "Publiser",
      actions: "Handlinger"
    }
  },

  // Analytics section
  analytics: {
    title: "Analyser",
    timePeriods: {
      last7days: "Siste 7 dager",
      last30days: "Siste 30 dager"
    },
    comparison: {
      compareToPrevious: "Sammenlign med forrige periode",
      stopComparing: "Stopp sammenligning med forrige periode"
    },
    sections: {
      searchLocations: "Søk lokasjoner"
    },
    cards: {
      sessions: "Økter",
      topSearches: "Topp søk",
      topLandingPageType: "Topp landingssidetype",
      topPageViewsBySession: "Topp sidevisninger per økt",
      topLocations: "Topp lokasjoner",
      topReferrers: "Topp henvisninger",
      searches: "Søk",
      topLandingPagesBySession: "Topp landingssider per økt"
    },
    chartLabels: {
      desktop: "Desktop"
    }
  },

}; 